import { render, staticRenderFns } from "./HmFooter.vue?vue&type=template&id=119798a1&scoped=true&"
var script = {}
import style0 from "./HmFooter.vue?vue&type=style&index=0&id=119798a1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119798a1",
  null
  
)

component.options.__file = "HmFooter.vue"
export default component.exports